  import React, { useState } from 'react';
  import { Card, Row, Col, Typography, Tag, Table, Radio, Input, Checkbox, Space, Slider, Rate } from 'antd';
  import { DownOutlined, UpOutlined } from '@ant-design/icons';
  import TmMasterTable from '../ReusableComponents/TmMasterTable';
  import style from '../../Styles/AddUser.module.css';
  import { reviewHeader } from '../../constant/tableHeader';
  const { Text } = Typography;



  const renderMatrixTableNew = (qItem, startIdx, displayNum, totalQuestions) => {
    const columns = qItem.matrixColumns || [];
    const rows = qItem.matrixRows || [];
    const isRequired = qItem.required;

    return (
      <div key={`matrix-${startIdx}`} style={{ marginBottom: 30, paddingBottom: 30, borderBottom: displayNum < totalQuestions ? '1px solid #e0e0e0' : 'none' }}>
        <Text strong style={{ fontSize: '15px', display: 'block', marginBottom: 15 }}>
          {displayNum}. {qItem.title || <em style={{ color: '#bbb' }}>Untitled Question</em>} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </Text>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ width: '250px' }}></th>
                {columns.map((col, i) => (
                  <th key={i} style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
                    {typeof col === 'object' ? col.title : col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((rowItem, rIdx) => {
                return (
                  <tr key={rIdx} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '15px 10px', color: '#444' }}>
                      {typeof rowItem === 'object' ? rowItem.title : rowItem}
                    </td>
                    {columns.map((col, colIdx) => (
                      <td key={colIdx} style={{ textAlign: 'center' }}>
                        <Radio disabled={true} />
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderInputType = (qItem) => {
    const options = qItem.options || [];
    const type = qItem.scaleType || 'text';

    switch (type) {
      case 'checkbox':
      case 'multiChoice':
        return (
          <Checkbox.Group disabled>
            <Space direction="vertical">
              {options.filter(opt => opt && (typeof opt === 'string' ? opt.trim() : String(opt?.title || '').trim())).map((opt, i) => (
                <Checkbox key={i} value={opt.title}>{opt.title}</Checkbox>
              ))}
            </Space>
          </Checkbox.Group>
        );

      case 'radio':
        return (
          <Radio.Group disabled>
            <Space direction="vertical">
              {options.filter(opt => opt && (typeof opt === 'string' ? opt.trim() : String(opt?.title || '').trim())).map((opt, i) => (
                <Radio key={i} value={opt.title}>{opt.title}</Radio>
              ))}
            </Space>
          </Radio.Group>
        );

      case 'slider':
      case 'sliders': {
        const sliderMin = Number(options?.[0]?.min ?? 0);
        const sliderMax = Number(options?.[0]?.max ?? 100);
        return (
          <div style={{ padding: '0 20px 30px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 12, color: '#888', minWidth: 20 }}>{sliderMin}</span>
              <Slider
                min={sliderMin}
                max={sliderMax}
                disabled
                tooltip={{ formatter: (val) => `${val}` }}
                style={{ flex: 1 }}
                styles={{
                  track: { backgroundColor: '#134780' },
                  handle: { borderColor: '#134780', backgroundColor: '#fff' },
                }}
              />
              <span style={{ fontSize: 12, color: '#888', minWidth: 28 }}>{sliderMax}</span>
            </div>
          </div>
        );
      }

      case 'rating': {
        const starCount = Number(options?.[0]?.title) || 5;
        return <Rate disabled value={0} count={starCount} />;
      }

      default:
        return (
          <Input.TextArea disabled rows={3} placeholder="Respondents will type their answer here..." />
        );
    }
  };

  const getEntityId = (item) => {
    if (item === null || item === undefined) return null;
    if (typeof item === 'object') {
      return item.id ?? item.value ?? item.user_id ?? null;
    }
    return item;
  };

  const getUserName = (item) =>
    item?.name ||
    (item?.first_name
      ? `${item.first_name} ${item.last_name || ''}`.trim()
      : null) ||
    item?.username ||
    item?.label ||
    item?.value ||
    '';

  const Review = ({
    title,
    description,
    periodId,
    periodList,
    startDate,
    endDate,
    anonymousResponse,
    allowResubmission,
    requireAllQuestions,
    approvers,
    approverList = [],
    contacts,
    estimatedAudience,
    categories,
    userIds = [],
    userList = [],
    departmentIds = [],
    departmentList = [],
  }) => {
    const [showQuestions, setShowQuestions] = useState(false);

    const periodName =
      periodList.find((p) => p.id === periodId)?.period_name || 'Not selected';

    const formatDate = (date) => {
      return date ? date.format('DD/MM/YYYY') : 'Not set';
    };

    // Resolve approver names
    const approverNames =
      Array.isArray(approvers) && approvers.length > 0
        ? approvers
            .map((item) => {
              const matched = approverList.find(
                (a) =>
                  a.id === item ||
                  a.id === Number(item) ||
                  a.value === item ||
                  a.value === Number(item),
              );
              if (matched)
                return (
                  matched.username ||
                  matched.name ||
                  matched.label ||
                  String(item)
                );
              return typeof item === 'string' || typeof item === 'number'
                ? String(item)
                : '';
            })
            .filter((name) => !!name)
            .join(', ')
        : '';

    // Fix 2: Show "No Approvers" instead of "Admin" when none selected
    const approverDisplay = approverNames || 'No Approvers';

    // Check if specific users were explicitly selected
    const hasSpecificUsers = Array.isArray(userIds) && userIds.length > 0;
    const hasDeptOnly = !hasSpecificUsers && Array.isArray(departmentIds) && departmentIds.length > 0;

    // Names of explicitly selected users
    const attendedUserNames =
      hasSpecificUsers
        ? userIds
            .map((uid) => {
              const matched = userList.find(
                (u) => String(getEntityId(u)) === String(uid),
              );
              if (matched) {
                const userName = getUserName(matched);
                return userName || String(uid);
              }
              return null;
            })
            .filter(Boolean)
        : [];

    // All users loaded for selected department(s)
    const allDepartmentUserNames =
      Array.isArray(userList) && userList.length > 0
        ? userList.map((user) => getUserName(user)).filter(Boolean)
        : [];

    // Final participant name list: explicit users → all users from userList
    const participantNames = hasSpecificUsers
      ? attendedUserNames
      : allDepartmentUserNames;

    return (
      <Card style={{ marginBottom: 20, borderRadius: 8 }}>
        <div className={style['title-style']}>Review Survey</div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '14px 20px',
              background: '#eef3fb',
              cursor: 'pointer',
              userSelect: 'none',
            }}
            onClick={() => setShowQuestions((v) => !v)}
          >
            <div>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
                Survey Title
              </Text>
              <Text strong style={{ fontSize: 15 }}>
                {title || 'Untitled Survey'}
              </Text>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                color: '#1a5f9e',
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              View All Questions
              {showQuestions ? (
                <UpOutlined style={{ fontSize: 12 }} />
              ) : (
                <DownOutlined style={{ fontSize: 12 }} />
              )}
            </div>
          </div>

          {/* Expanded Question List */}
          {showQuestions && (
            <div style={{ background: '#fff' }}>
              {!categories || categories.length === 0 ? (
                <div style={{ padding: '24px', textAlign: 'center' }}>
                  <Text type="secondary">No questions added yet.</Text>
                </div>
              ) : (
                (() => {
                  let globalQIdx = 0;
                  const totalQuestions = categories.reduce((sum, cat) => sum + (cat.questions ? cat.questions.length : 0), 0);
                  return categories.map((cat, catIdx) => (
                    <div key={cat.localId || catIdx}>

                      {/* Questions */}
                      {cat.questions && cat.questions.length > 0 ? (
                        <div style={{ padding: '20px' }}>
                          {cat.questions.map((q) => {
                            globalQIdx += 1;
                            const qNum = globalQIdx;
                            if (q.scaleType === 'matrix') {
                              return renderMatrixTableNew(q, qNum, qNum, totalQuestions);
                            } else {
                              return (
                                <div key={q.localId || qNum} style={{ marginBottom: 30, paddingBottom: 30, borderBottom: qNum < totalQuestions ? '1px solid #e0e0e0' : 'none' }}>
                                  <Text strong style={{ fontSize: '15px', display: 'block', marginBottom: 20 }}>
                                    {qNum}. {q.title || <em style={{ color: '#bbb' }}>Untitled Question</em>} {q.required && <span style={{ color: 'red' }}>*</span>}
                                  </Text>
                                  {renderInputType(q)}
                                </div>
                              );
                            }
                          })}
                        </div>
                      ) : (
                        <div style={{ padding: '10px 20px' }}>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            No questions in this category.
                          </Text>
                        </div>
                      )}
                    </div>
                  ));
                })()
              )}
            </div>
          )}
      




    
        {/* ─── Summary Information Panel ─── */}
        <Card
          style={{ marginBottom: 16,}}
          bodyStyle={{ padding: 24 }}
        >
          {/* <div style={{ marginBottom: 16, fontWeight: 600, fontSize: 16, color: '#134780' }}>
            Survey Details
          </div> */}
          <Row gutter={[24, 16]}>
            <Col span={6}>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>Start Date</Text>
              <Text strong>{formatDate(startDate)}</Text>
            </Col>
            <Col span={6}>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>End Date</Text>
              <Text strong>{formatDate(endDate)}</Text>
            </Col>
          
            <Col span={6}>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>Total Questions</Text>
              <Text strong>
                {categories?.reduce((total, cat) => total + (cat.questions?.length || 0), 0) || 0}
              </Text>
            </Col>
       
            <Col span={6}>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>Period</Text>
              <Tag color="orange" style={{ marginTop: 4 }}>{periodName}</Tag>
            </Col>
                 <Col span={6}>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>Survey Participants</Text>
              <Text strong>
                {participantNames.length > 0 ? participantNames.join(', ') : 'No participants selected'}
              </Text>
            </Col>
  <Col span={6}>
              <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>Approver</Text>
              <Text strong>{approverDisplay}</Text>
            </Col>
          </Row>
        </Card>

        {(() => {
          // Build participant list: specific users → all users in userList
          const tableUsers = hasSpecificUsers
            ? userIds
                .map((uid) => {
                  const matched = userList.find((u) => String(getEntityId(u)) === String(uid));
                  return matched || null;
                })
                .filter(Boolean)
            : Array.isArray(userList)
            ? userList
            : [];

          if (tableUsers.length === 0) return null;
          const dataSource = tableUsers.map((user, idx) => ({
            id: user?.id || idx,
            key: idx,
            serialNo: idx + 1,
            _userName: getUserName(user),
            email: user?.email || user?.email_id || '--',
            employeeCode: user?.employeeCode || user?.employee_code || user?.emp_code || '--',
            designation: user?.designation_name || user?.designation || '--',
            department: user?.department_name || user?.department || '--',
            phone: user?.phone || user?.phone_number || user?.mobile || '--',
          }));

          return (
        
        
              <TmMasterTable
                rows={dataSource}
                columns={reviewHeader}
                custom={[]}
                toggleModal={null}
                handleDelete={() => {}}
                  hidePagination={true}
              />
        
          );
        })()}

      </Card>
    );
  };

  export default Review;
